import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-user-info-inputs',
    template: `
        <div class="user-info-name">
            <app-input
                class="user-info-input user-info-name__input"
                [controlName]="(controlNamePrefix || '') + 'firstName'"
                [parentForm]="parentForm"
                [label]="'user_information.first_name' | translate"
                cssClasses="input__input-element--white-background"
            ></app-input>
            <app-input
                class="user-info-input user-info-name__input"
                [controlName]="(controlNamePrefix || '') + 'lastName'"
                [parentForm]="parentForm"
                [label]="'user_information.last_name' | translate"
                cssClasses="input__input-element--white-background"
            ></app-input>
        </div>
        <app-input
            class="user-info-input"
            [controlName]="(controlNamePrefix || '') + 'email'"
            [parentForm]="parentForm"
            [label]="'user_information.email' | translate"
            type="email"
            cssClasses="input__input-element--white-background"
        ></app-input>
        <app-input
            class="user-info-input"
            cssClasses="input__input-element--white-background"
            [controlName]="(controlNamePrefix || '') + 'phone'"
            [inputMode]="'tel'"
            [label]="'user_information.phone_number' | translate"
            [parentForm]="parentForm"
        ></app-input>
        <app-input
            class="user-info-input"
            [controlName]="(controlNamePrefix || '') + 'address'"
            [parentForm]="parentForm"
            [label]="'user_information.address' | translate"
            cssClasses="input__input-element--white-background"
        ></app-input>
        <div class="user-info-postal-number-city">
            <app-input
                class="user-info-input user-info-postal-number-city__postal-number"
                cssClasses="input__input-element--white-background"
                [controlName]="(controlNamePrefix || '') + 'zipCode'"
                [inputMode]="'decimal'"
                [label]="'user_information.postal_number' | translate"
                [parentForm]="parentForm"
            ></app-input>
            <app-input
                class="user-info-input user-info-postal-number-city__city"
                [controlName]="(controlNamePrefix || '') + 'city'"
                [parentForm]="parentForm"
                [label]="'user_information.city' | translate"
                cssClasses="input__input-element--white-background"
            ></app-input>
        </div>
    `,
})
export class UserInfoInputsComponent {
    @Input() parentForm: UntypedFormGroup;
    @Input() controlNamePrefix?: string;
}
